import React, { Component } from "react";
import { Table } from "reactstrap";
import ComisionAlcance from "../../../../types/ComisionAlcance";
import { Styled } from "../../../../toolkit/decorators/Artifact";
import s from "./styles.scss";
import {
  formatGroupFirstBy,
  formatMoney,
  formatPercent
} from "../../../helpers/formatters";

interface Props {
  alcances: ComisionAlcance[];
}

@Styled(s)
export default class ConfiguracionAlcancesTable extends Component<Props> {
  render() {
    const { alcances } = this.props;

    if (!alcances || alcances.length === 0) {
      return (
        <div className="text-center p-4">
          <p>No hay comisiones configuradas para este tipo.</p>
        </div>
      );
    }

    const porMembresia = formatGroupFirstBy(
      alcances,
      c => `${c.idMembresia || "sin-membresia"}_${c.precioVentaEsperado}`
    );
    const membresias = Object.values(porMembresia);

    const porcentajes = alcances[0].porcentajes || [];

    return (
      <div className={s.porcentajeTable}>
        <Table bordered size="sm" className={s.comisionTable}>
          <thead>
            <tr className={s.headerRow}>
              <th rowSpan={2} colSpan={2} className={s.alcanceHeader}>
                % Consolidado
              </th>

              {membresias.map((membresia, idx) => (
                <th key={idx} className={s.membresiaHeader}>
                  {membresia.membresia && (
                    <span className={s.membresiaTitulo}>
                      {membresia.membresia}
                      <br />
                    </span>
                  )}
                  {membresia.aplicaPromo && (
                    <span className={s.membresiaTitulo}>
                      Token Promocional
                      <br />
                    </span>
                  )}
                  <span className={s.precioEsperado}>
                    {membresia.precioVentaEsperado
                      ? formatMoney(membresia.precioVentaEsperado)
                      : ""}
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {porcentajes.map((porcentaje, idx) => (
              <tr key={idx}>
                <td
                  className={`${s.rangoCell} ${
                    porcentaje.sustitutoVendedorNuevo ? s.sustituto : ""
                  }`}
                >
                  {porcentaje.sustitutoVendedorNuevo && "* "}
                  {porcentaje.rangoInicial}%
                </td>
                <td
                  className={`${s.rangoCell} ${
                    porcentaje.sustitutoVendedorNuevo ? s.sustituto : ""
                  }`}
                >
                  {porcentaje.sustitutoVendedorNuevo && "* "}
                  {porcentaje.rangoFinal < 999 ? (
                    <>{porcentaje.rangoFinal}%</>
                  ) : (
                    <> o más</>
                  )}
                </td>

                {membresias.map((membresia, mIdx) => {
                  const comisionMembresia = alcances.find(
                    c =>
                      c.idMembresia == membresia.idMembresia &&
                      c.precioVentaEsperado == membresia.precioVentaEsperado
                  );
                  const porcentajeMembresia =
                    comisionMembresia && comisionMembresia.porcentajes
                      ? comisionMembresia.porcentajes.find(
                          p => p.rangoInicial === porcentaje.rangoInicial
                        )
                      : undefined;

                  return (
                    <td key={mIdx} className={s.importeCell}>
                      {porcentajeMembresia
                        ? porcentajeMembresia.comisionPorcentual
                          ? formatPercent(porcentajeMembresia.importeComision)
                          : formatMoney(porcentajeMembresia.importeComision)
                        : "-"}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </Table>
        {porcentajes.some(p => p.sustitutoVendedorNuevo) && (
          <div className={s.footnote}>
            * Alcance inicial para asesores nuevos
          </div>
        )}
      </div>
    );
  }
}
